import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PartnerContactInfo } from '../fragments';

export default gql`
  mutation createPartnerContact($input: PartnerContactCreateInput!) {
    createPartnerContact(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      partnerContact {
        ...PartnerContactInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${PartnerContactInfo}
`;
